import React from 'react';
import type { SvgProps } from 'react-native-svg';
import { Path, Svg } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface MoonFilledIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

const MoonFilledIcon: React.FC<MoonFilledIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
      <Path
        d="M14 8.5A6 6 0 0 1 7.5 2 6 6 0 1 0 14 8.5z"
        fill={colors[color]}
        stroke={colors[color]}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </Svg>
  );
};

MoonFilledIcon.displayName = 'MoonFilledIcon';

export { MoonFilledIcon };
